import {
  OrderConfirmation,
  ResendConfirmationParsedResponse,
  ResendConfirmationStatus,
} from 'redux/order-confirmation/types/types';
import { appInsights } from 'utils/telemetry/app-insights';
import { confirmationLegacyApiService } from 'api/re-send-confirmation.legacy.api.service';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { orderConfirmationApiService } from 'api/order-confirmation.api.service';
import { parseAxiosError } from 'utils/errors';

export const getOrderConfirmationRegion = createAsyncThunk(
  'order-confirmation-region/fetch',
  async (
    { region, saleToken }: { region: number; saleToken?: string },
    { rejectWithValue },
  ) => {
    try {
      // The token always comes from an earlier response: order placement for
      // the confirmation page, order history for order details.
      if (!saleToken) {
        return rejectWithValue('not_found');
      }

      const data: OrderConfirmation =
        await orderConfirmationApiService.findByRegion(saleToken, region);
      if (data) {
        return data;
      }
      return rejectWithValue('not_found');
    } catch (error) {
      appInsights.trackEvent({ name: 'Order Confirmation Error' });
      return rejectWithValue(parseAxiosError(error).message);
    }
  },
);

export const sendSpecialProductMail = createAsyncThunk(
  'send-specialproduct-mail/fetch',
  async (saleId: number, { rejectWithValue }) => {
    try {
      const { data } =
        await confirmationLegacyApiService.sendSpecialProductsMail(saleId);
      const parsedResponse = JSON.parse(
        data.d,
      ) as ResendConfirmationParsedResponse;
      if (parsedResponse._Status === ResendConfirmationStatus.Error) {
        return rejectWithValue(parsedResponse);
      }
      return parsedResponse;
      return rejectWithValue('not_found');
    } catch (error) {
      return rejectWithValue(parseAxiosError(error).message);
    }
  },
);
